export function areAllElementsNumbers(arr) {
  let allNumbers = true;

  for (let i = 0; i < arr.length; i++) {
    const element = arr[i];

    // Check for empty string
    if (element === '' || isNaN(Number(element))) {
      allNumbers = false;
      break;
    }
  }
  
  return allNumbers;
}
